import { Component, computed, inject, input, model, signal } from '@angular/core';
import { Business } from 'src/model/business';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { getBankLogoByName } from '../bank.config';
import { DIALOG_CONTROLLER } from '../BaseDialog/dialog-controller';
import { ALERT_TYPE, SUCCESS_MESSAGES } from '../constants';
import { ConfirmationDialogComponent } from '../Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from '../Shared/shared-service.service';

@Component({
  selector: 'app-linked-business-list',
  standalone: false,
  templateUrl: './linked-business-list.component.html',
  styleUrl: './linked-business-list.component.scss',
})
export class LinkedBusinessListComponent {
  private sharedService = inject(SharedService);
  private faService = inject(FinanceAccountService);
  private dialog = inject(DIALOG_CONTROLLER, { optional: true });

  fa = model.required<FinanceAccount>();
  allBusinessList = input.required<Business[]>();
  selectedBusiness = signal<number>(undefined);
  businessList = computed(() => {
    const b = this.allBusinessList();
    const fa = this.fa();
    const ids = new Set(fa.BusinessIds);
    return b.reduce((acc, current) => {
        if (ids.has(current.Id)) acc.linked.push(current);
        else acc.selection.push(current);
        return acc;
      }, {linked: [] as Business[], selection: [] as Business[]});
  })

  readonly getBankLogoByName = getBankLogoByName;

  async link() {
    const fa = this.fa();
    await this.faService.linkBusinessToFinanceAccount(fa.Id, this.selectedBusiness());
    this.fa.update(f => {
      return Object.assign(new FinanceAccount(), f, { BusinessIds: [...fa.BusinessIds, this.selectedBusiness()] });
    });
    this.dialog?.emitData(this.fa());
    this.selectedBusiness.set(null);
    this.sharedService.openAlert(SUCCESS_MESSAGES.ACTION('linked', 'finance account'), ALERT_TYPE.SUCCESS);
  }

  unlink(business: Business) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    const i = modalRef.componentInstance as ConfirmationDialogComponent;
    const fa = this.fa();
    i.message = `Confirm to unlink this finance account ${fa.Code} | ${fa.Description} from ${business.Name}?`;
    modalRef.result.then(async confirm => {
      if (confirm) {
        await this.faService.unlinkBusinessToFinanceAccount(fa.Id, business.Id);
        this.fa.update(fa => {
          const i = fa.BusinessIds.indexOf(business.Id);
          fa.BusinessIds.splice(i, 1);
          return Object.assign(new FinanceAccount(), fa);
        });
        this.dialog?.emitData(this.fa());
        this.sharedService.openAlert(SUCCESS_MESSAGES.ACTION('unlinked', 'finance account'), ALERT_TYPE.SUCCESS);
      }
    });
  }
}
